 import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection,AngularFirestoreDocument } from '@angular/fire/firestore';
import { Observable,Subscription } from 'rxjs';
import { Events} from 'ionic-angular';
import { first } from 'rxjs/operators';
import { User } from  '../../models/user';
import { Storage } from '@ionic/storage';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
/*
  Generated class for the DealershipProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
import { environment } from '../../environments/environment';
const CLOUD_FUNC_URL = environment.cloudUrl;

@Injectable()
export class DealershipProvider {

  dealerManagersCollection: AngularFirestoreCollection<any>;
  dealerManagers$:Observable<any[]>;
  dealerManagers:Array<any>;
  dealerManagersSubs:Subscription;


  premisesListCollection: AngularFirestoreCollection<any>;
  premisesList$:Observable<any[]>;
  premisesList:Array<any>;
  premisesListSubs:Subscription;


  dealershipListCollection: AngularFirestoreCollection<any>;
  dealershipList$:Observable<any[]>;
  dealershipList:Array<any>;
  dealershipListSubs:Subscription;

  constructor(private afs: AngularFirestore,private storage: Storage, public events:Events,private http: HttpClient) {
    console.log('Hello DealershipProvider Provider');
  }


   intializeSubscriptions(){

     //  this.dealerManagersCollection = this.afs.collection<any>('dealerManagers');
     //  this.dealerManagers$ = this.dealerManagersCollection.snapshotChanges().pipe(
     //      map(actions => actions.map(a => {
     //        const data = a.payload.doc.data();
     //        const id = a.payload.doc.id;
     //        return data;
     //     })));
    
     // this.dealerManagersSubs = this.dealerManagers$.subscribe( (dealerManagers:any) => {  

     //        this.dealerManagers = dealerManagers;
     //        console.log(dealerManagers);
     //        this.events.publish('dealership:dealerManagersList',this.dealerManagers);
     // });

     //  this.premisesListCollection = this.afs.collection<any>('premises');
     //  this.premisesList$ = this.premisesListCollection.snapshotChanges().pipe(
     //      map(actions => actions.map(a => {
     //        const data = a.payload.doc.data();
     //        const id = a.payload.doc.id;
     //        return {id, ...data};
     //  })));
    
     // this.premisesListSubs = this.premisesList$.subscribe( (premisesList:any) => {  

     //        this.premisesList = premisesList;
     //        console.log(premisesList);
     //        this.events.publish('dealership:premisesList',this.premisesList);
     // });


      this.dealershipListCollection = this.afs.collection<any>('dealership');
      this.dealershipList$ = this.dealershipListCollection.snapshotChanges().pipe(
          map(actions => actions.map(a => {
            const data = a.payload.doc.data();
            const id = a.payload.doc.id;
            return {id, ...data};
      })));
    
     this.dealershipListSubs = this.dealershipList$.subscribe( (dealershipList:any) => {  

            this.dealershipList = dealershipList;
            console.log(dealershipList);
             this.events.publish('dealership:dealershipList',this.dealershipList);
     });

     this.events.subscribe('dealership:getDealerManagersList', (dealershipId) => {

        this.getDealerManagersList(dealershipId);

     });

      this.events.subscribe('dealership:addDealerManager', (dealerManager:any) => {

        this.addDealerManager(dealerManager);

      });

       this.events.subscribe('dealership:updateDealerManager', (dealerManager:any) => {

        this.updateDealerManager(dealerManager);

      });


       this.events.subscribe('dealership:getPremisesList', (dealershipId) => {

          this.getPremisesList(dealershipId);

     });

      this.events.subscribe('dealership:addPremises', (premises:any) => {

        this.addPremises(premises);

      });

       this.events.subscribe('dealership:updatePremises', (premises:any) => {

        this.updatePremises(premises);

      });

      this.events.subscribe('dealership:getDealershipList', () => {

        this.events.publish('dealership:dealershipList',this.dealershipList);

     });

      this.events.subscribe('dealership:addDealership', (dealership:any) => {

        this.addDealership(dealership);

      });

       this.events.subscribe('dealership:updateDealership', (dealership:any) => {

        this.updateDealership(dealership);

      });

   }

   async getDealerManagersList(dealershipId){

      const dealerManagers = await this.afs.collection('dealerManagers',ref => ref.where('dealershipId','==',dealershipId).orderBy('name')).snapshotChanges().pipe(
                  map(actions => actions.map(a => {
                    const data = a.payload.doc.data() as any;
                    const id = a.payload.doc.id;
                    let creationDate,lastAccessDate; 
                    if(data.creationTime){
                        creationDate = data.creationTime.toDate();
                    }
                    if(data.lastAccessTime){
                        lastAccessDate = data.lastAccessTime.toDate();
                    }
                    
                    return { id, creationDate,lastAccessDate, ...data };
      }))).pipe(first()).toPromise();

     console.log("dealer managers");
     console.log(dealerManagers);
     this.events.publish('dealership:dealerManagersList',dealerManagers);
   }


   async getPremisesList(dealershipId){

      const premisesList = await this.afs.collection('premises',ref => ref.where('dealershipId','==',dealershipId).orderBy('name')).snapshotChanges().pipe(
                  map(actions => actions.map(a => {
                    const data = a.payload.doc.data() as any;
                    const id = a.payload.doc.id;
                    return { id, ...data };
      }))).pipe(first()).toPromise();


     console.log(premisesList);
     this.events.publish('dealership:premisesList',premisesList);
   }

   async addDealerManager(dealerManager){

          this.http.post(CLOUD_FUNC_URL + 'addDealerManager',dealerManager).subscribe((res: any) => {
                    console.log(res);
                    if (res.success) {
                       this.events.publish('dealership:addDealerManagerSuccess');
                    }
                    else{
                       this.events.publish('dealership:addDealerManagerFailed');
                    }

         });

   }

   async updateDealerManager(dealerManager){

     if(dealerManager && dealerManager.uid){
        await this.afs.collection('users').doc(dealerManager.uid).update(dealerManager);
        await this.afs.collection('dealerManagers').doc(dealerManager.uid).update(dealerManager);

        this.events.publish('dealership:updateDealerManagerSuccess');
     }
     else{
       this.events.publish('dealership:updateDealerManagerFailed');
     }
    
   }

   async addPremises(premises){

          if(premises){
            await this.afs.collection('premises').add(premises);
            this.events.publish('dealership:addPremisesSuccess');
          }
          else{
            this.events.publish('dealership:addPremisesFailed');
          }
   }

   async updatePremises(premises){

     if(premises && premises.id){
        await this.afs.collection('premises').doc(premises.id).update(premises);
        this.events.publish('dealership:updatePremisesSuccess');
     }
     else{
       this.events.publish('dealership:updatePremisesFailed');
     }
    
   }


    async addDealership(dealership){

          if(dealership){
            await this.afs.collection('dealership').add(dealership);
            this.events.publish('dealership:addDealershipSuccess');
          }
          else{
            this.events.publish('dealership:addDealershipFailed');
          }
   }

   async updateDealership(dealership){

     if(dealership && dealership.id){
        await this.afs.collection('dealership').doc(dealership.id).update(dealership);
        this.events.publish('dealership:updateDealershipSuccess');
     }
     else{
       this.events.publish('dealership:updateDealershipFailed');
     }
    
   }

   removeSubscriptions(){
      if(this.dealerManagersSubs){
           this.dealerManagersSubs.unsubscribe();
      }
      if(this.premisesListSubs){
           this.premisesListSubs.unsubscribe();
      }
      if(this.dealershipListSubs){
           this.dealershipListSubs.unsubscribe();
      }
      this.events.unsubscribe('dealership:addDealerManager');
      this.events.unsubscribe('dealership:getDealerManagersList');
      this.events.unsubscribe('dealership:updateDealerManager');
      this.events.unsubscribe('dealership:addPremises');
      this.events.unsubscribe('dealership:getPremisesList');
      this.events.unsubscribe('dealership:updatePremises');
      this.events.unsubscribe('dealership:addDealership');
      this.events.unsubscribe('dealership:getDealershipList');
      this.events.unsubscribe('dealership:updateDealership');
   }



}



// WEBPACK FOOTER //
// ./src/providers/dealership/dealership.ts